import gql from 'graphql-tag';

export default gql`
  mutation ($id: MongoID!) {
    removeAnnounce(_id: $id) {
      recordId
    }
  }
`;
